var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecruitersMenuItem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20.814,
    height: 22.774,
    viewBox: "0 0 20.814 22.774",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-1293254"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3212",
    "data-name": "Rectangle 3212",
    width: 12.915,
    height: 12.915,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-1293254-1263254"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3208",
    "data-name": "Rectangle 3208",
    width: 10.816,
    height: 14.56,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_98441",
    "data-name": "Group 98441",
    transform: "translate(-134.639 -418.935)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26809",
    "data-name": "Group 26809",
    transform: "translate(142.538 418.935)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26808",
    "data-name": "Group 26808",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10051",
    "data-name": "Group 10051",
    clipPath: "url(#clip-path-1293254)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13050",
    "data-name": "Path 13050",
    d: "M12.765,12,9.555,8.794a5.385,5.385,0,1,0-.76.76L12,12.764a.538.538,0,0,0,.76-.76M5.395,9.7a4.3,4.3,0,1,1,4.3-4.3,4.3,4.3,0,0,1-4.3,4.3",
    transform: "translate(0 0)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26982",
    "data-name": "Group 26982",
    transform: "translate(134.639 427.148)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10043",
    "data-name": "Group 10043",
    clipPath: "url(#clip-path-1293254-1263254)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13044",
    "data-name": "Path 13044",
    d: "M67.609,7.217A3.609,3.609,0,1,0,64,3.609a3.609,3.609,0,0,0,3.609,3.609m0-6.014A2.406,2.406,0,1,1,65.2,3.609,2.406,2.406,0,0,1,67.609,1.2",
    transform: "translate(-62.196)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13045",
    "data-name": "Path 13045",
    d: "M5.413,298.667A5.419,5.419,0,0,0,0,304.08a.6.6,0,0,0,1.2,0,4.21,4.21,0,1,1,8.42,0,.6.6,0,0,0,1.2,0,5.419,5.419,0,0,0-5.413-5.413",
    transform: "translate(0 -290.247)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecruitersMenuItem);
export default __webpack_public_path__ + "static/media/recruiters-menu-item.c88dc9243eb42d5f89fed0ad80a0aeda.svg";
export { ForwardRef as ReactComponent };